/**
 * Handle File various status
 */
export enum UploadedFileType {
  MAIN = 'MAIN',
  ANNEX = 'ANNEX',
  DATA = 'DATA',
  SPOOL = 'SPOOL',
  FDP = 'FDP',
  SIG = 'SIG',
  PRINCIPAL = 'P',
}
